<template lang="pug">
.role
    TagInfo(:label="`${roleAbbreviation(practitioner?.profession)}`" :type="'table'")  
    v-label.name(v-if="showLabel") {{` ${practitioner?.firstName || ''} ${practitioner?.lastName || ''}` }}
    v-tooltip( v-if="showToolTip" activator="parent" location="bottom") {{` ${practitioner?.firstName || ''} ${practitioner?.lastName || ''}` }}
</template>

<script setup lang="ts">
const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  showToolTip: {
    type: Boolean,
    default: () => true,
  },
  showLabel: {
    type: Boolean,
    default: () => false,
  },
})
const { getPractitionerById } = usePractitionersStore()

const practitioner = ref<any>(null)

watch(
  () => props.id,
  (newValue) => {
    if (newValue) {
      practitioner.value = getPractitionerById(newValue)
    }
  },
  { immediate: true },
)
</script>

<style lang="stylus" scoped>
.role
  display flex
  gap 3px
  align-items center
  .name
    display inline-block
    color var(--Text-4, #747474) !important
    opacity 1
    font-weight 400
    font-family var(--font-family-text-contrast)
    font-size 10px
    font-style normal
</style>
